import React from "react";
import "./index.css";

function FieldLabel({ label, children, className = "" }) {
  return (
    <label className={`field-label ${className}`.trim()}>
      <span>{label}</span>
      {children}
    </label>
  );
}

export default FieldLabel;
